<template>
        <v-layout xs12 class="pl-2">
            <v-flex xs3 class="grey--text">{{label}}</v-flex>
            <v-flex class="subtitle-1">
                {{valeur}}
            </v-flex>
        </v-layout>
</template>

<script>
    export default {
        props: ['label','valeur'],
    }

</script>

<style scoped>
</style>